function PaymentStatusBadge({ status }: { status: string }) {
  let badgeClass = '';
  let text = '';

  switch (status) {
    case 'paid':
      badgeClass = 'bg-green-50 text-green-600';
      text = 'Paid';
      break;
    case 'unpaid':
      badgeClass = 'bg-yellow-50 text-yellow-600';
      text = 'Unpaid';
      break;
    case 'overdue':
      badgeClass = 'bg-red-50 text-red-600';
      text = 'Overdue';
      break;
    default:
      badgeClass = 'bg-gray-100 text-gray-800';
      text = 'Unknown';
  }

  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded md:text-xs text-[9px] lg:text-sm font-semibold ${badgeClass}`}
    >
      {text}
    </span>
  );
}

export default PaymentStatusBadge;
